var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmitted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 372.9,
    height: 207.728,
    viewBox: "0 0 372.9 207.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "submitted",
    transform: "translate(-9 -11.672)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8186",
    "data-name": "Path 8186",
    d: "M292,147s34-3.7,39,6.4-12.1,57.5-12.1,57.5H265.4l1.7-40Z",
    fill: "#fd863d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6763",
    "data-name": "Group 6763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8187",
    "data-name": "Path 8187",
    d: "M275.7,90.1s5.8-1.2,8.7-2.2,6.3-3.4,8.1-3.9,19.9-1.6,23.9-1.8c3.9-.3,13.6-2.4,13.6-2.4l8.9-27.5s-15.5,3.4-23.9,6.3-20.5,7.3-20.5,7.3Z",
    fill: "#ec896b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6745",
    "data-name": "Group 6745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8188",
    "data-name": "Path 8188",
    d: "M181.3,218c0-.3,5.8-24.1,7.3-34.1,1.6-10,7.9-33.6,7.6-35.7s-14.4-15.2-17-16.5-4.7-10-6.3-10.8a33.7,33.7,0,0,1-11-11.3c-3.7-6.3-11.3-22.6-7.9-32.3s18.1-7.1,19.1-8.1,3.1-2.6,5.5-1c0,0,1-4.7,5-4.7,3.9,0,4.7,2.9,5.8,1.8,1-1,3.4-2.1,8.1,1.6s14.7,19.7,14.7,22.3-8.4,5-8.4,5,6.8,3.1,7.9,5c1,1.8,0,2.9,2.1,2.9s3.7-.5,5,1.3,1.6,2.4,2.4,2.4,5-3.7,8.7-1.8c3.7,1.8,9.7-1.8,9.7-1.8l20.7,5.2L215.9,217.9Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8189",
    "data-name": "Path 8189",
    d: "M205.9,93.2c-3.6-3.2-9-2.8-13.4-3.7-.3-.1-.7-.1-1-.2a.9.9,0,0,0,0-1.1c-1-1.4-2.6-2.4-3.7-3.7a30.194,30.194,0,0,1-3.5-4.5,41.951,41.951,0,0,1-4.4-10.2,1.044,1.044,0,1,0-2,.6,30.8,30.8,0,0,0,4.4,10.8,49.555,49.555,0,0,0,3.4,4.6c.7.8,1.6,1.8,2.5,2.7a41.515,41.515,0,0,1-10-4.7c-1.1-.7-2,1-1,1.7a40.209,40.209,0,0,0,13.6,6.3c4.5,1.1,9.7.7,13.6,3.5C205.5,96,206.9,94.1,205.9,93.2Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8190",
    "data-name": "Path 8190",
    d: "M206.5,116.1a59.176,59.176,0,0,1-5.3,16.2c-1.2,2.5-2.4,5-3.5,7.5s-2.6,5.1-3.1,7.8c-.3,1.5,1.9,2.7,2.7,1.1,1.3-2.6,2.1-5.4,3.3-8.1s2.5-5.3,3.6-8c2.3-5.3,4.1-10.7,4.3-16.5C208.5,114.9,206.7,114.9,206.5,116.1Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8191",
    "data-name": "Path 8191",
    d: "M209.9,105.5a39.953,39.953,0,0,0-6.7,7.5c-2.2,2.9-4.2,6-6.1,9.1a54.021,54.021,0,0,0-4.5,9c-1,2.9-1.9,6.5-1,9.5a.761.761,0,0,0,1.5-.2c.1-1.6,0-3.2.2-4.8a24.992,24.992,0,0,1,1.2-4.5,48.671,48.671,0,0,1,4.5-8.8c1.7-2.8,3.6-5.6,5.5-8.3a41.637,41.637,0,0,1,6.4-7.5C211.8,106,210.7,104.9,209.9,105.5Z",
    fill: "#333",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8192",
    "data-name": "Path 8192",
    d: "M237.9,65.2s-16,1.8-28.3,1.3-17.3.5-17.8,1,8.1,9.2,10,11.8c1.8,2.6,7.3,9.2,9.2,9.7,1.8.5,17.8-4.2,24.1-6C241.3,81.2,237.9,65.2,237.9,65.2Z",
    fill: "#ec896b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6761",
    "data-name": "Group 6761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8193",
    "data-name": "Path 8193",
    d: "M243.5,96.8a83.868,83.868,0,0,0-8.4,1.8c-2.4.8-7.3,12.3-7.3,14.2s7.9-9.2,9.4-8.1c1.6,1-.5,5.8.3,8.1a44.493,44.493,0,0,0,3.2,6.4l8.3-10.6Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8194",
    "data-name": "Path 8194",
    d: "M248.8,28.2c3.3-6.7,6.8-5.1,6.8-5.1,1.6-11.4,14.5-16.3,27.2-5.1a46.537,46.537,0,0,1,13.3,21.5,42.659,42.659,0,0,0-1.2-6.4,35.86,35.86,0,0,0-6.6-12.7c-.8-.9.3-1.5,1.1-.6,3.5,4.1,6.4,8.2,7.8,13.4,1,3.7,1.7,8.2.6,12.1,1.8.8,9.9,5.2,1.7,21-9.2,17.7-27,26.4-27,26.4L261,92.3,245.9,48.4C245.8,48.2,245.5,34.9,248.8,28.2Z",
    fill: "#86282c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8195",
    "data-name": "Path 8195",
    d: "M276.2,83.3s-2.7,10-2.6,15.4c.1,5.3,0,6.5,0,6.5s-19.6,15-21.6,19.6c-.8,1.8-6.4,9.2-7,9.2-.2,0-.6-1.4-.7-1.6-.3-.7-.6-1.3-.9-2a32.513,32.513,0,0,1-1.5-4,24.384,24.384,0,0,1-1.3-8.5c.2-3.9,1.6-7.5,2.3-11.3.8-4.1.1-7.9-.4-12-.1-1,.5-1.6.8-2.5.4-1.1.5-2.2.9-3.3C250.5,70.6,276.2,83.3,276.2,83.3Z",
    fill: "#ec896b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8196",
    "data-name": "Path 8196",
    d: "M244.4,91.1a3.529,3.529,0,0,1,2.8-1.8c1.4.1,2.8.1,4.1.2,4.1.2,8.1.4,12.2.6,1.4.1,2.8.1,4.3.2A21.435,21.435,0,0,1,256.5,101c-4.5,1.8-11.4-.4-13.4-4.9a4.711,4.711,0,0,1-.4-1.7,4.552,4.552,0,0,1,.8-1.9A8.049,8.049,0,0,1,244.4,91.1Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6747",
    "data-name": "Group 6747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8197",
    "data-name": "Path 8197",
    d: "M243.8,45.8c-1.5,3.3-13.8,25.5-11.4,36,1.3,5.5,7.5,9.9,12,11.7,13.9,5.5,24.3-.7,31.5-9.1,0,0,15.2-.2,15-13.1-.1-9.5-11.4-.7-11.4-.7a73.981,73.981,0,0,1,1.8-11.9c.7-3.1,0-7.2-2.9-8.6-8.6-4.3-22.2-9-21.8-18.8C256.6,31.2,246.4,40.4,243.8,45.8Z",
    fill: "#ec896b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6749",
    "data-name": "Group 6749"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6748",
    "data-name": "Group 6748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8198",
    "data-name": "Path 8198",
    d: "M245.8,63.3a1.5,1.5,0,0,1,1.9-.2c.6.4,1.3.8,1.9,1.2a1.24,1.24,0,0,1,.5,1.7,1.5,1.5,0,0,1-1.9.2c-.6-.4-1.3-.8-1.9-1.2A1.164,1.164,0,0,1,245.8,63.3Z",
    fill: "#d75b43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6751",
    "data-name": "Group 6751"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6750",
    "data-name": "Group 6750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8199",
    "data-name": "Path 8199",
    d: "M266.5,45.2c1.1,1.2,2.3,2.3,3.3,3.5,1,1.3,1.9,2.7,2.8,4,.9,1.2-.9,2.7-1.8,1.4-1-1.3-1.8-2.8-2.8-4-1-1.3-2.3-2.3-3.3-3.5C263.7,45.5,265.5,44.1,266.5,45.2Z",
    fill: "#531916"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8200",
    "data-name": "Path 8200",
    d: "M241.3,47.7a6.1,6.1,0,0,1,3.6-1.5c1.4-.3,2.1,1.9.6,2.2a5.772,5.772,0,0,0-2.6.9A1.132,1.132,0,1,1,241.3,47.7Z",
    fill: "#531916"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8201",
    "data-name": "Path 8201",
    d: "M235.6,63.8s.8,2.5,2.8,2.8c2.1.3,12.7.8,19.4,4.9,4,2.5,11,3.7,16.4.7s6.5-10.8,6.5-10.8l2.1,7a19.041,19.041,0,0,0-4,5c-1.8,3.2-3.2,13.3-7.4,12.6,0,0-6.8,14.1-21.8,11.3C226,92.8,228.5,72.8,235.6,63.8Z",
    fill: "#86282c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8202",
    "data-name": "Path 8202",
    d: "M240.5,73.3c3.4,2.6,5.4,3,9.6,3.3,1.2.1,1.3,1.1,0,1.1-4.2-.1-7.9.5-10.9-3A.962.962,0,0,1,240.5,73.3Z",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8203",
    "data-name": "Path 8203",
    d: "M268.2,60.1a18.535,18.535,0,0,0-4.4-1.8,2.01,2.01,0,0,1-.8-.4c-1.4-1.4,3-1,3.5-.9a5.261,5.261,0,0,1,2.6,1.5c.5.5,1.5,1.6,1.5,2.4,0,.1,0,.1-.1.2s-.1.1-.2.1a2.127,2.127,0,0,1-1.5-.7C268.7,60.3,268.4,60.2,268.2,60.1Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6760",
    "data-name": "Group 6760"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8204",
    "data-name": "Path 8204",
    d: "M243.8,53.5h1.9c.9,0-.3-1.5-.7-1.7a2.966,2.966,0,0,0-1.6-.2,17.731,17.731,0,0,0-3.2.5c-1.4.5-.8,1.6.5,1.5C241.8,53.5,242.8,53.5,243.8,53.5Z",
    fill: "#1a1a1a"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_8205",
    "data-name": "Path 8205",
    d: "M236.9,124.9c.3-.5,5.5-8.7,7.3-10.8s11.8-8.9,13.4-11a9.755,9.755,0,0,1,4.7-2.9s7.3-2.1,10-2.1c2.6,0,16.5,10.2,16.5,10.2l-5,12.3-43.5,12.1Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8206",
    "data-name": "Path 8206",
    d: "M275,116.9a11.181,11.181,0,0,1-1.5-5c-.3-2-.6-4-1-5.9a36.931,36.931,0,0,0-1.1-5.6,2.2,2.2,0,0,0-2.7-1.6c-.9.2-.7,1.7.2,1.6,1-.1,1.3,4,1.4,4.6.3,1.6.5,3.1.8,4.7.4,2.8.5,5.9,2.2,8.2C274,118.9,275.7,118,275,116.9Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8207",
    "data-name": "Path 8207",
    d: "M263.8,105.9c2.6-.3,7.9,2.4,7.9,2.4a33.829,33.829,0,0,0-.5-5.5,6.477,6.477,0,0,0-2.4-3.9l.1-.2c-3,.6-6.5,1.6-6.5,1.6a9.755,9.755,0,0,0-4.7,2.9,30.746,30.746,0,0,1-4.2,3.7C256.1,106.6,261.8,106.1,263.8,105.9Z",
    fill: "#333",
    opacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6762",
    "data-name": "Group 6762"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8208",
    "data-name": "Path 8208",
    d: "M292.8,217.2s6.8-16,9.7-24.4,9.2-20.2,9.2-20.2a61.068,61.068,0,0,0,8.1-10.5,33.406,33.406,0,0,0,4.5-11.3s12.6-17,19.9-24.1,11-12.3,13.1-16.3c2.1-3.9-.3-6,3.1-7.9,3.4-1.8,5.5-.3,8.1-10s5.5-29.1,1.8-33-13.4-5-13.4-5-1.3-3.4-3.4-3.1l-2.1.3s-7.1-4.5-17.8,1.6-16.8,13.4-16.3,17.6,4.5,10.2,4.5,10.2-9.4,8.4-11,11-1.3,2.6-2.6,3.4-3.7,5-3.4,6.8a42.936,42.936,0,0,0-6,1c-1.3.5-3.1-2.1-5.2.3s-5,0-7.6,1.6a15.686,15.686,0,0,0-4.2,3.9,44.791,44.791,0,0,0-14.9,4.5c-6.8,3.7-19.1,9.7-19.1,9.7l-10.5.3L220.4,143l-27.8,74.5Z",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8209",
    "data-name": "Path 8209",
    d: "M356.9,53.9c-6.3-1.2-13.6,1.1-18.8,4.6-5.1,3.4-10.4,9.2-10.3,15.7a70.521,70.521,0,0,0-6.1,4.7c-1.5,1.2.6,3.3,2.1,2.1a42.618,42.618,0,0,1,8.1-5.8c1.3-.7,2.9-1,4.1-2a15.941,15.941,0,0,0,2.5-3.3,19.431,19.431,0,0,1,6.7-5.7,27.019,27.019,0,0,1,8.4-2.4c1.1-.2.7-1.8-.3-1.9-5.9-.6-12.2,3-16,7.3a30.721,30.721,0,0,1-2.7,3.6,5.535,5.535,0,0,1-2.2,1,15.384,15.384,0,0,0-1.9.8c.8-5.2,5.1-9.6,9.4-12.3a25.453,25.453,0,0,1,7.9-3.5,37.124,37.124,0,0,1,8.8-1C357.7,55.9,358,54.1,356.9,53.9Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8210",
    "data-name": "Path 8210",
    d: "M317.5,132.4a59.277,59.277,0,0,0,10.4-15c.3-.7-.7-1.4-1.1-.6a62.737,62.737,0,0,1-9.8,13.6c-1.9,2.1-3.8,4.1-5.7,6.1-.8.9-1.6,1.7-2.3,2.5a16.83,16.83,0,0,1-3.6-5.1c-3.8-7.7-5.2-16.7-5-25.2a.65.65,0,0,0-1.3,0c-.3,9.5.7,19.4,5.6,27.7a16.522,16.522,0,0,0,3.3,4.1,8.954,8.954,0,0,0-.8,2.3,75.047,75.047,0,0,1-4.6,16.2,67.185,67.185,0,0,1-4,7.5,40.17,40.17,0,0,0-3.9,7c-1.1,3.2-.8,6.8-1.6,10.1s-2.2,6.5-3.3,9.7c-.3.9,1.1,1.5,1.6.7a48.064,48.064,0,0,0,3.2-8.2,50.893,50.893,0,0,0,1.4-8.7c.3-3,1.7-5.5,3.3-8.1a67.176,67.176,0,0,0,4.2-7.4,62.7,62.7,0,0,0,5.1-15.7,26.619,26.619,0,0,1,.7-3.9c0-.1.1-.2.1-.3a53.455,53.455,0,0,1,5,4.5c2.7,2.5,7.1,4.9,10.6,2.5a.943.943,0,1,0-1-1.6c-3.9,2.4-7.6-1.5-10.2-4a31.655,31.655,0,0,0-3.5-2.9,10.7,10.7,0,0,1,1.4-1.6C313.7,136.5,315.6,134.5,317.5,132.4Z",
    fill: "#333",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8211",
    "data-name": "Path 8211",
    d: "M235.7,126.4c-.4,1.3-.7,2.5-1,3.8-3.2,11.1-9.5,20.9-14.1,31.5-1.3,3-2.2,6.1-3.6,9-1.4,3-3.4,5.5-5,8.4a33.952,33.952,0,0,0-3.6,8.8c-.8,3.3-.9,6.6-1.5,9.9-1.3,6.3-6.8,11.2-7.1,17.8-.1,1.4,2.2,1.7,2.4.3.8-5.7,4.7-10,6.6-15.3,1.1-3.2,1-6.6,1.6-9.8a33.294,33.294,0,0,1,3.1-9.2c1.5-2.9,3.6-5.4,5.1-8.3a87.075,87.075,0,0,0,3.6-8.9c2.4-6,5.5-11.7,8.3-17.5a94.918,94.918,0,0,0,5-11.8c.8-2.4,1.3-4.9,1.9-7.4a17.352,17.352,0,0,1,1.3-3.6,31.826,31.826,0,0,0,1.6-3.2c.1-.4.2-.9-.2-1.1-.3-.1-.6.1-.9.3A13.642,13.642,0,0,0,235.7,126.4Z",
    fill: "#333",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8212",
    "data-name": "Path 8212",
    d: "M283.2,144a6.2,6.2,0,0,0-2.9-1.2c-1.2-.3-2.4-.6-3.7-.8a117.943,117.943,0,0,0-32.4-2.5,1.161,1.161,0,0,0-.7,1.9,1.326,1.326,0,0,0-1.3.9,141.915,141.915,0,0,0-4.6,14.4,65.844,65.844,0,0,0-1.4,7.5c-.2,1.9-.8,4.5.2,6.3a12.064,12.064,0,0,0,2.1,2.4c.9.9,1.8,1.7,2.7,2.5,1.7,1.6,3.5,3.1,5.3,4.5a7.494,7.494,0,0,0,5.7,1.9A52.317,52.317,0,0,0,259,180c2.3-.7,4.6-1.3,6.9-2.1a47.49,47.49,0,0,0,6.3-2.3c1.8-.9,2.8-2.6,3.6-4.6.9-2.4,1.7-4.8,2.6-7.3,1.8-5,3.7-9.9,5.3-15C284.2,147.2,284.5,145.2,283.2,144Zm-2.1,4.9c-.4,1.1-.8,2.2-1.2,3.4-.8,2.2-1.5,4.3-2.3,6.5s-1.6,4.5-2.4,6.7a34.669,34.669,0,0,1-2.3,6.1c-1,1.8-3,2.3-4.8,2.9-2.1.7-4.1,1.4-6.2,2-2,.6-4,1.2-6.1,1.8-2,.6-4.4,1.7-6.4.7a23.461,23.461,0,0,1-4.7-3.6c-1.6-1.3-3.1-2.8-4.6-4.2-.7-.7-1.8-1.5-1.9-2.7a20.554,20.554,0,0,1,.2-3.5,63.629,63.629,0,0,1,1.4-7.6,121.051,121.051,0,0,1,4.7-14.4,1.165,1.165,0,0,0-.3-1.3,157.812,157.812,0,0,1,25.7,1.7,61.765,61.765,0,0,1,6.2,1.2c1,.2,2,.4,3,.7.7.2,2.3.2,2.5,1.1C281.9,147.1,281.4,148.2,281.1,148.9Z",
    fill: "#333",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8213",
    "data-name": "Path 8213",
    d: "M285.8,105.2a10.145,10.145,0,0,0-2.6,1.6c-.6.5-1,1.2-1.9,1.3a59.744,59.744,0,0,0-6.1.8,52.942,52.942,0,0,0-11.3,4.7,71.974,71.974,0,0,0-10,6.6,29.052,29.052,0,0,0-7.6,8.4,1.153,1.153,0,0,0,1.8,1.4,76.437,76.437,0,0,1,10.5-7.4c1.1-.6-.1-1.3-1.2-.8-1.4.6-2.7,1.3-4,2,.9-.8,1.8-1.5,2.7-2.2a71.625,71.625,0,0,1,9.9-6.2,45.45,45.45,0,0,1,11.3-4.3c1-.2,2-.3,3-.4a5.832,5.832,0,0,0,2.3-.2,4.31,4.31,0,0,0,1.7-1.3,12.705,12.705,0,0,1,2.7-1.8C288.6,106.7,287.3,104.5,285.8,105.2Z",
    fill: "#333"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6772",
    "data-name": "Group 6772"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6765",
    "data-name": "Group 6765"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8214",
    "data-name": "Path 8214",
    d: "M32.5,161.2s.8-10.9,2-14.6c1.2-3.6,1.6-5.5,2.1-5.5.4,0-.4,5.5.5,8.6a113.794,113.794,0,0,1,1.7,16.8c0,3.6-4.1,4.6-4.1,4.6Z",
    fill: "#006935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8215",
    "data-name": "Path 8215",
    d: "M35.5,167.1s1.2-6.4,4.5-10.9c3.3-4.6,5.4-5.9,5.8-5.5.4.5-1.7,2.3-2.5,6.4s-1.2,8.2-1.2,8.2l-5,6.4L35,168.5Z",
    fill: "#008839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8216",
    "data-name": "Path 8216",
    d: "M28.4,169.8a36.055,36.055,0,0,1-.9-10.4c.4-5.5,1.6-7.7,1.2-9.5s-.4-2.3,1.2-.5c1.7,1.8,6.3,11.8,5.9,20s-5.4,6.8-5.4,6.8Z",
    fill: "#008839"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8217",
    "data-name": "Path 8217",
    d: "M31.8,174.8a15.033,15.033,0,0,1,5-7.7c4.1-3.7,8.3-7.8,9.1-10,.8-2.3,1.2-2.7,1.2-2.3,0,.5.9,5-5.3,15s-7,10.9-7,10.9Z",
    fill: "#006935"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8218",
    "data-name": "Path 8218",
    d: "M23.9,180.7a35.452,35.452,0,0,0-3.4-15.4c-3.8-8.2-6.3-11.3-5.9-11.8s7.1,3.2,12.9,12.2c5.9,9.1,7.1,14.1,7.1,14.1a28.978,28.978,0,0,1,9.1-12.3c6.6-5,13.3-8.2,14.1-10.1.8-1.8.8.9-1.2,3.6-2.1,2.7-9.9,9.1-11.6,11.9-1.7,2.7-4.1,7.3-4.1,7.3s-2.1-.9-2.5-.4-1.7,1.8-1.7,1.8a7.766,7.766,0,0,0-2.5.5c-1.2.5-3.3-2.3-5-1.8a6.265,6.265,0,0,0-2.9,2.3S25.1,180.7,23.9,180.7Z",
    fill: "#009341"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8219",
    "data-name": "Path 8219",
    d: "M34.7,175.9c-.9-3.6-3.6-6.6-5.8-9.3-.5-.6-.9-.1-.4.5,2.2,2.9,3.5,6.1,5.3,9.3C34,177,34.8,176.6,34.7,175.9Z",
    fill: "#006935"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_8220",
    "data-name": "Path 8220",
    d: "M16.3,180.3c.2-.4,32.4-1.5,34.5,0s-3.3,25.3-4,26.8c-.6,1.5-24.5,2.1-25.9.2C19.4,205.4,15.6,181.5,16.3,180.3Z",
    fill: "#bcc0c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8221",
    "data-name": "Path 8221",
    d: "M46.8,207.1a57.976,57.976,0,0,0,1.5-6,16.4,16.4,0,0,1-10.9,1.4c-9.9-2.3-10.8-22.1-10.8-22.7-5.7.2-10.3.4-10.3.6-.6,1.3,3.1,25.1,4.6,27C22.3,209.2,46.2,208.5,46.8,207.1Z",
    fill: "#acb1b0",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8222",
    "data-name": "Path 8222",
    d: "M19.9,184.9a1.591,1.591,0,0,0-.9-.9.55.55,0,0,0-.5.3.446.446,0,0,0,0,.5.454.454,0,0,0,0,.5.926.926,0,0,0,1.2.3A.663.663,0,0,0,19.9,184.9Z",
    fill: "#acb1b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8223",
    "data-name": "Path 8223",
    d: "M20.1,182.1a.551.551,0,0,0,0,1.1A.551.551,0,1,0,20.1,182.1Z",
    fill: "#acb1b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8224",
    "data-name": "Path 8224",
    d: "M38.8,203.8a1.319,1.319,0,0,0-1-.9,1.442,1.442,0,0,0-1.3.3.92.92,0,0,0-.1,1.2.749.749,0,0,0,.1.5.918.918,0,0,0,.6.4.854.854,0,0,0,.7,0c.2-.1.5-.2.6-.4A.778.778,0,0,0,38.8,203.8Z",
    fill: "#acb1b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8225",
    "data-name": "Path 8225",
    d: "M36.3,200.1a1.08,1.08,0,0,0-.3-.7.908.908,0,0,0-.7-.3.9.9,0,0,0-.9.9v.1a1.08,1.08,0,0,0,.3.7.908.908,0,0,0,.7.3,1.08,1.08,0,0,0,.7-.3.908.908,0,0,0,.3-.7C36.3,200.2,36.3,200.2,36.3,200.1Z",
    fill: "#acb1b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8226",
    "data-name": "Path 8226",
    d: "M48.4,197.5a1.025,1.025,0,0,0-1-1,1,1,0,0,0-1,1v.1a1.08,1.08,0,0,0,.3.7,1,1,0,0,0,1.7-.7Z",
    fill: "#acb1b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8227",
    "data-name": "Path 8227",
    d: "M45.1,182a.95.95,0,1,0,0,1.9C46.3,184,46.3,182,45.1,182Z",
    fill: "#acb1b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8228",
    "data-name": "Path 8228",
    d: "M46.4,206.7c-8.3,0-16.6-.3-24.8.2a.9.9,0,0,0,0,1.8c8.2.4,16.6.2,24.8.2C47.7,208.8,47.7,206.7,46.4,206.7Z",
    fill: "#acb1b0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6767",
    "data-name": "Group 6767"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6766",
    "data-name": "Group 6766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8229",
    "data-name": "Path 8229",
    d: "M65.9,205.4s-.3,2.9,1.3,3.4,147.9,0,147.9,0-.8-2.9-2.1-2.9-70.8-.8-70.8-.8Z",
    fill: "#91a9bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8230",
    "data-name": "Path 8230",
    d: "M155.1,205.7c0-.1-.1-.3-.1-.4-5.1-.1-12.8-.1-12.8-.1l-76.3.3s-.3,2.9,1.3,3.4c.9.3,50.6.3,90.9.2A3.965,3.965,0,0,1,155.1,205.7Z",
    fill: "#6e8a9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8231",
    "data-name": "Path 8231",
    d: "M63.3,206.5s89.2.5,90.5.3c1.3-.3,2.4-2.4,2.4-2.4s-21.2-72.1-22.8-73.7-91.8,1-93.4,2.6S60.9,205.4,63.3,206.5Z",
    fill: "#aec0d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8232",
    "data-name": "Path 8232",
    d: "M156.1,204.4s-21.2-72.1-22.8-73.7-91.8,1-93.4,2.6q-.15.15,0,.9c10.3-1.1,89.3-3.5,91.6-2.2,2.2,1.2,21.1,67.6,23,74.4A5.7,5.7,0,0,0,156.1,204.4Z",
    fill: "#91a9bc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8233",
    "data-name": "Path 8233",
    d: "M163.3,206.5c-1.2-.1-2.5,0-3.7,0a.7.7,0,0,0,0,1.4c1.2,0,2.5.1,3.7,0C164.3,207.9,164.3,206.6,163.3,206.5Z",
    fill: "#6e8a9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8234",
    "data-name": "Path 8234",
    d: "M165.2,206.5a.7.7,0,0,0,0,1.4A.7.7,0,0,0,165.2,206.5Z",
    fill: "#6e8a9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8235",
    "data-name": "Path 8235",
    d: "M167.1,206.6a.7.7,0,0,0,0,1.4A.7.7,0,0,0,167.1,206.6Z",
    fill: "#6e8a9b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8236",
    "data-name": "Path 8236",
    d: "M172.9,206.8a21.663,21.663,0,0,0-3.6-.1.7.7,0,0,0,0,1.4,14.473,14.473,0,0,0,3.6-.1A.625.625,0,0,0,172.9,206.8Z",
    fill: "#6e8a9b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6770",
    "data-name": "Group 6770"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8237",
    "data-name": "Path 8237",
    d: "M282,193.9s-.4-2.4,0-2.9c.4-.4,3.7-.4,3.7-.4s-.4-3.7,0-3.7,90.1-.4,90.1.4.8,2.9,0,2.9h-5.3s.4,3.7,0,3.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8238",
    "data-name": "Path 8238",
    d: "M375.8,187.4c0-.5-32.3-.5-58.2-.5a15.062,15.062,0,0,1,.1,3c-3.5,0-7,.1-10.4.1-6.3,0-12.6-.2-18.8.1-.8,0-.7.5.2.5,6.3.3,12.4.1,18.7.1h7v3.1h56.2c.4,0,0-3.7,0-3.7h5.3C376.6,190.3,375.8,188.2,375.8,187.4Z",
    fill: "#e4e9eb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6769",
    "data-name": "Group 6769"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8239",
    "data-name": "Path 8239",
    d: "M274.7,195.2a12.207,12.207,0,0,1,0,12.2l61.5.4,2.4-7.7-2.9-4.1-1.6-1.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8240",
    "data-name": "Path 8240",
    d: "M361.4,194a10.751,10.751,0,0,0-3.1-.1c-1.8,0-3.6-.1-5.3-.1H342.3c-8.3,0-16.6.1-24.9.1H295.9c-7.3,0-14.7-.4-21.9.2-.1,0-.3.1-.4.1h-.2a.7.7,0,0,0,0,1.4c5,0,15.5.1,15.6,0,2.3,0,4.6-.1,7-.1h21.5c5.3,0,10.6,0,16,.1.8.4,2,3,2.3,5.5.2,2.7-1.4,5.5-2.2,5.9H317.5c-14.6,0-29.4-.4-44,0-1,0-.8,1.6.2,1.6,14.6.5,55.9,0,59.6,0h24.1c2.1,0,4.7.4,6.5-1a4.948,4.948,0,0,0,1.4-2.3,10.5,10.5,0,0,0,.8-3.5c.2-2.9-1.2-6.6-4.1-7.8C361.6,194.1,361.5,194.1,361.4,194Z",
    fill: "#f1404c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8241",
    "data-name": "Path 8241",
    d: "M361.7,194.1c-.1,0-.2-.1-.3-.1a10.751,10.751,0,0,0-3.1-.1c-1.8,0-3.6-.1-5.3-.1H334.6c3,1.3,3.8,5.4,3.6,8.4a8.754,8.754,0,0,1-3.7,6.4h22.6c2.1,0,4.7.4,6.5-1a4.948,4.948,0,0,0,1.4-2.3,10.5,10.5,0,0,0,.8-3.5C366,198.9,364.6,195.2,361.7,194.1Z",
    fill: "#c31e21"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6771",
    "data-name": "Group 6771"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8242",
    "data-name": "Path 8242",
    d: "M240.3,178.1s-6.3-2-6.8,2.2c-.5,4.3.8,19.2,6.1,20.7C244.8,202.5,240.3,178.1,240.3,178.1Z",
    fill: "#d99b2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8243",
    "data-name": "Path 8243",
    d: "M269.1,172.8s-2.1,34.7-3.7,35.7c-1.6,1.1-25.2.9-25.2.4s-3.7-35.1-3.7-36.7C236.5,170.7,269,169.7,269.1,172.8Z",
    fill: "#f0b43f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8244",
    "data-name": "Path 8244",
    d: "M261.9,191.1c.5-5.1.7-10.2.7-15.4a1.7,1.7,0,0,1,3.4,0,113.319,113.319,0,0,1-.6,15.4C265.2,193.3,261.7,193.4,261.9,191.1Z",
    fill: "#ffce7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8245",
    "data-name": "Path 8245",
    d: "M262,195.2c2,0,2.6,4,.6,4S260,195.2,262,195.2Z",
    fill: "#ffce7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8246",
    "data-name": "Path 8246",
    d: "M247,157.9c1-2.1,2.6-3.8,3.8-5.8,1.2-1.9,2.1-4.3,1.5-6.5a10.044,10.044,0,0,0-1.7-3c-.9-1.2-1.8-2.5-2.6-3.7a12.23,12.23,0,0,1-1.7-2.9c-1-2.8,0-5.9.9-8.7-.2,2-.3,4.2.7,5.9a9.83,9.83,0,0,0,3.7,3.3c1.7,1.1,3.3,2.1,5,3.2a29.882,29.882,0,0,1,6,4.6,9.481,9.481,0,0,1,2.6,6.9c-.3,2.8-2.3,5.2-4.6,6.8s-5,2.6-7.5,4a10.885,10.885,0,0,0-3.7,3c-.9,1.4-.5,2.8-1.1,4.2C245.2,167,245.6,160.8,247,157.9Z",
    fill: "#fff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3102",
    "data-name": "Rectangle 3102",
    width: 372.9,
    height: 10.8,
    transform: "translate(9 208.6)",
    fill: "#aa6449"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitted);
export default __webpack_public_path__ + "static/media/submitted.61b0a91ccc55fa546be23a6ad7c80566.svg";
export { ForwardRef as ReactComponent };